module.exports = __webpack_public_path__ + "static/media/company_info.c5056265.svg";